import { Timestamp } from 'firebase/firestore';

export const isSameDay = (a, b) => {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
};

export const getTimetamp = () => {
  return Timestamp.fromDate(new Date()); //.toMillis()//Timestamp.fromDate(new Date());
};

export const dateFromFirebase = (timestamp) => {
  const date = new Timestamp(timestamp.seconds, timestamp.nanoseconds).toDate();
  if (date instanceof Date && !isNaN(date)) {
    return date;
  }
  return;
};

export const formatDateToLocale = (date, locale = 'fr-FR') => {
  return new Intl.DateTimeFormat(locale).format(date);
};

export const formatedCalendarDate = (value) => {
  return new Date(value).toLocaleDateString();
};

export const formatedDate = (timestamp) => {
  const date = new Timestamp(timestamp.seconds, timestamp.nanoseconds).toDate();
  return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
};

export const stringToDate = (s) => {
  return new Date(s).toLocaleDateString();
};

export const todayISO = () => {
  const offset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
  return new Date(Date.now() - offset).toISOString().slice(0, -1);
};

export const dateRemaining = (dateString) => {
  // const createdAt = new Timestamp(timestamp.seconds, timestamp.nanoseconds).toDate()
  const createdAt = new Date();
  const targetDate = new Date(dateString);
  // targetDate.setDate(targetDate.getDate() + 15);
  // targetDate.setMonth(targetDate.getMonth()+3);
  const difference = targetDate - createdAt;
  const days = Math.round(difference / (1000 * 3600 * 24));
  return days;
};

export const getRemainingStatus = (dateString) => {
  const days = dateRemaining(dateString);
  const status = { color: 'text-orange-500', days, status: 'ok' };

  if (days < 0) {
    status.color = 'text-red-500';
    status.status = 'danger';
  } else if (days <= 7) {
    status.color = 'text-orange-500';
    status.status = 'warning';
  }

  return status;
};
